import { TradeType, validateAndParseAddress } from '@uniswap/sdk-core';
import invariant from 'tiny-invariant';
import { toHex } from './toHex';
var ZERO_HEX = '0x0';
export var getV2SwapCallParamsFromTrade = function (trade, options) {
    var etherIn = trade.inputAmount.currency.isNative;
    var etherOut = trade.outputAmount.currency.isNative; // the router does not support both ether in and out
    !!(etherIn && etherOut) ? invariant(false, 'ETHER_IN_OUT') : void 0;
    !(!('ttl' in options) || options.ttl > 0) ? invariant(false, 'TTL') : void 0;
    var to = validateAndParseAddress(options.recipient);
    var amountIn = toHex(trade.maximumAmountIn(options.allowedSlippage));
    var amountOut = toHex(trade.minimumAmountOut(options.allowedSlippage));
    var path = trade.routes[0].path.map(function (token) {
        return token.address;
    });
    // const deadline =
    //   'ttl' in options
    //     ? '0x' + (Math.floor(new Date().getTime() / 1000) + options.ttl).toString(16)
    //     : '0x' + options.deadline.toString(16)
    var paramsIn = {
        amountIn: amountIn,
        amountOutMin: amountOut,
        path: path,
        to: to,
    };
    var paramsOut = {
        amountOut: amountOut,
        amountInMax: amountIn,
        path: path,
        to: to,
    };
    if (trade.tradeType === TradeType.EXACT_INPUT) {
        return {
            params: paramsIn,
            value: ZERO_HEX,
        };
    }
    else {
        return {
            params: paramsOut,
            value: ZERO_HEX,
        };
    }
};
